import { env } from '$env/dynamic/public';
import { EntityType, MiscTypes } from '$lib/sanity/types';
import type { LinkPage } from '$lib/sanity/schemas';
import { generatePagePathFromSlug } from './pages/routes';

export function toAbsolutePath(path: string) {
  return `${env.PUBLIC_BASE_URL}${path}`;
}

export const newsPath = (absolute = false) => {
  const path = '/news';

  return absolute ? toAbsolutePath(path) : path;
};

export const newsPostPath = (slug: string, absolute = false) => {
  const path = `/inside/${slug}`;

  return absolute ? toAbsolutePath(path) : path;
};

export const newsTagPagePath = (slug: string, absolute = false) => {
  const path = `/news/${slug}`;

  return absolute ? toAbsolutePath(path) : path;
};

export const legalPagePath = (slug: string, absolute = false) => {
  const path = `/legal/${slug}`;

  return absolute ? toAbsolutePath(path) : path;
};

export const documentPagePath = (slug: string, absolute = false) => {
  const path = `/documents/${slug}`;

  return absolute ? toAbsolutePath(path) : path;
};

export const linkPagePath = (page: LinkPage, absolute = false) => {
  let path = '';

  switch (page._type) {
    case EntityType.NewsTopicPage:
      path = newsTagPagePath(page.topic.slug.current);
      break;
    case EntityType.NewsPost:
      path = newsPostPath(page.slug.current);
      break;
    case EntityType.Page:
      path = generatePagePathFromSlug(page.slug.current, page.hierarchyItems);
      break;
    case EntityType.LegalPage:
      path = legalPagePath(page.slug.current);
      break;
    case MiscTypes.Document:
      path = documentPagePath(page.slug.current);
      break;
  }

  return absolute ? toAbsolutePath(path) : path;
};
